import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconWarningSvg } from "./IconWarningSvg.mjs";
const IconWarning = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconWarningSvg, ...iconProps });
};
export {
  IconWarning
};
